import { createContext, useCallback, useContext, useMemo, useState } from "react";

const UICtx = createContext(null);

export function UIProvider({ children }) {
  const [demo, setDemo] = useState({ open: false, example: null });
  const [bookingOpen, setBookingOpen] = useState(false);
  const [chosenExample, setChosenExample] = useState(null);

  const openDemo = useCallback((example) => {
    if (example) setChosenExample(example);
    setDemo({ open: true, example: example || null });
  }, []);
  const closeDemo = useCallback(() => setDemo((d) => ({ ...d, open: false })), []);

  const value = useMemo(
    () => ({ demo, openDemo, closeDemo, bookingOpen, setBookingOpen, chosenExample, setChosenExample }),
    [demo, openDemo, closeDemo, bookingOpen, chosenExample]
  );
  return <UICtx.Provider value={value}>{children}</UICtx.Provider>;
}

export const useUI = () => useContext(UICtx);
